import React, {useState} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import {FiArrowRight, FiCalendar, FiShield, FiCheck} from 'react-icons/fi';
import BookingModal from './BookingModal';

const BOOKING_URL = 'https://links.myvoicelocal.com/widget/bookings/10-minute-call-with-stu';

const VSLActionHub = () => {
  const [showBooking, setShowBooking] = useState(false);

  return (
    <section className="py-16 md:py-20 bg-stone-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_100%,rgba(217,119,6,0.08),transparent)]" />
      <div className="max-w-4xl mx-auto px-4 relative z-10">
        <motion.div
          initial={{opacity: 0, y: 20}}
          whileInView={{opacity: 1, y: 0}}
          viewport={{once: true}}
          className="text-center mb-10"
        >
          <span className="inline-block px-5 py-2 rounded-full bg-stone-800 border border-stone-700 text-amber-400 text-sm font-bold uppercase tracking-widest mb-6">
            Limited Spots Available
          </span>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white font-serif tracking-tight">
            Ready to Commit to Your<br />
            <span className="font-light italic text-stone-400">6-Week Transformation?</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-5">
          <motion.div
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            viewport={{once: true}}
            className="bg-white rounded-[2rem] p-8 border-2 border-amber-400 shadow-2xl shadow-amber-900/10 flex flex-col"
          >
            <div className="flex items-center gap-2 mb-5">
              <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
              <span className="text-amber-700 text-sm font-black uppercase tracking-widest">Fast Track</span>
            </div>
            <h3 className="text-stone-900 font-bold text-2xl font-serif mb-4 leading-tight">Ready to start immediately?</h3>
            <p className="text-stone-500 text-lg font-light leading-relaxed mb-7 flex-grow">
              Complete your 60-second medical intake and begin your physician review today.
            </p>
            <motion.a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{scale: 1.03, y: -2}}
              whileTap={{scale: 0.97}}
              className="w-full bg-stone-900 hover:bg-amber-700 text-white font-bold py-4 px-5 rounded-2xl text-base flex items-center justify-center gap-2 transition-all shadow-2xl shadow-stone-900/25 mb-4"
            >
              Check Eligibility and Enroll
              <SafeIcon icon={FiArrowRight} />
            </motion.a>
            <p className="text-center text-stone-400 text-sm font-medium flex items-center justify-center gap-1.5">
              <SafeIcon icon={FiShield} className="text-amber-500 text-sm" />
              $997 Pay in Full or 2x $549 — 6-Week Results Guarantee
            </p>
          </motion.div>

          <motion.div
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            viewport={{once: true}}
            transition={{delay: 0.1}}
            id="book-call"
            className="bg-white rounded-[2rem] p-8 border border-stone-200 shadow-lg flex flex-col"
          >
            <div className="flex items-center gap-2 mb-5">
              <SafeIcon icon={FiCalendar} className="text-stone-400 text-sm" />
              <span className="text-stone-500 text-sm font-black uppercase tracking-widest">Talk First</span>
            </div>
            <h3 className="text-stone-900 font-bold text-2xl font-serif mb-4 leading-tight">Have health questions first?</h3>
            <p className="text-stone-500 text-lg font-light leading-relaxed mb-7 flex-grow">
              Schedule a brief 10-minute strategy call with Program Specialist Stuart.
            </p>
            <motion.button
              whileHover={{scale: 1.03}}
              whileTap={{scale: 0.97}}
              onClick={() => setShowBooking(true)}
              className="w-full border border-stone-200 bg-white text-stone-700 hover:border-amber-400 hover:text-amber-700 font-bold py-4 px-5 rounded-2xl text-base flex items-center justify-center gap-2 transition-all shadow-lg mb-4"
            >
              <SafeIcon icon={FiCalendar} />
              Book a 10-Min Strategy Call
            </motion.button>
            <div className="flex flex-wrap justify-center gap-4">
              {['Zero pressure', 'Health history', 'Check eligibility'].map((t, i) => (
                <span key={i} className="flex items-center gap-1.5 text-stone-400 text-sm">
                  <SafeIcon icon={FiCheck} className="text-amber-500 text-sm" />{t}
                </span>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
      {showBooking && <BookingModal onClose={() => setShowBooking(false)} />}
    </section>
  );
};

export default VSLActionHub;